import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "third-party-bill-content"
};
import ThirdPartyHeader from '@/views/thirdPartyBill/components/ThirdPartyHeader.vue';
import ThirdPartyContent from '@/views/thirdPartyBill/components/ThirdPartyContent.vue';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'thirdPartyBill'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const tableRef = ref(null);
    const returnSearch = searchObj => {
      var _tableRef$value;
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.searchData(searchObj);
    };
    const resetDimension = key => {
      var _tableRef$value2;
      (_tableRef$value2 = tableRef.value) === null || _tableRef$value2 === void 0 || _tableRef$value2.resetDimension(key);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ThirdPartyHeader, {
        onReturnSearch: returnSearch,
        onResetDimension: resetDimension
      }), _createVNode(ThirdPartyContent, {
        ref_key: "tableRef",
        ref: tableRef
      }, null, 512)]);
    };
  }
});